export default "__VITE_ASSET__DbVrQlXI__"